import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  bottom: -", "px;\n  box-sizing: border-box;\n  color: ", ";\n  font-size: ", "px;\n  height: ", "px;\n  left: 0;\n  line-height: 1.17;\n  opacity: ", ";\n  padding-top: 0.6em;\n  position: absolute;\n  transition: opacity 0.1s ease-out 0.1s;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { color } from '@scp/ui-shared/theme/variables';
import { FIELD_SUBTEXT_HEIGHT, FIELD_SUBTEXT_FONT_SIZE } from './constants';
var COLOR_BY_TYPE = {
  error: color.invalid,
  hint: color.label
};
/**
 * Displays error text below Field.
 * @example ./__docs__/FieldSubtext.md
 */

export var FieldSubtext = styled.div.attrs({
  role: 'alert'
})(_templateObject(), FIELD_SUBTEXT_HEIGHT, function (_ref) {
  var type = _ref.type;
  return COLOR_BY_TYPE[type];
}, FIELD_SUBTEXT_FONT_SIZE, FIELD_SUBTEXT_HEIGHT, function (props) {
  return props.children ? 1 : 0;
});
FieldSubtext.defaultProps = {
  children: ''
};